import { render } from "./ArticleTextColumns.vue?vue&type=template&id=35cff11e"
import script from "./ArticleTextColumns.vue?vue&type=script&lang=js"
export * from "./ArticleTextColumns.vue?vue&type=script&lang=js"

import "./ArticleTextColumns.vue?vue&type=style&index=0&id=35cff11e&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__